import { asArray } from "./asArray.ts";

export function filterNulls<T>(obj: Iterable<T | null | undefined>): T[] {
    return asArray(obj).filter((x): x is T => x !== null && x !== undefined);
}

export function filterObjNulls<T extends object>(obj: T) {
    const result = {} as { [K in keyof T]: NonNullable<T[K]> };
    for (const k in obj) {
        const v = obj[k];
        if (v != null) {
            result[k] = v;
        }
    }
    return result;
}
